import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import {
    AppBar, Toolbar, Box, Typography, CircularProgress, Container, Grid
} from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { usePublicClientState, usePublicPortalBasePath } from './context/public-client-context';

function Copyright() {
    return (
        <Typography variant="body2" color="text.secondary" align="center">
            {'Painel da Transparência © '}{new Date().getFullYear()}
        </Typography>
    );
}

export function PublicLayout() {
    const { client, loading, error } = usePublicClientState();
    const basePath = usePublicPortalBasePath();
    const navigate = useNavigate();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%' }}>
            <AppBar
                position="static"
                elevation={0}
                sx={{ borderBottom: '1px solid', borderColor: 'divider' }}
            >
                <Toolbar sx={{ px: { xs: 2, md: 4 }, minHeight: { xs: 72, md: 88 } }}>
                    <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer', flexGrow: 1 }}
                        onClick={() => navigate(basePath)}
                    >
                        {client?.brandLogo ? (
                            <Box
                                component="img"
                                src={client.brandLogo}
                                alt={client.name}
                                sx={{ height: 44, width: 44, objectFit: 'contain', borderRadius: 1, bgcolor: 'primary.contrastText' }}
                            />
                        ) : (
                            <Box
                                sx={{
                                    height: 44, width: 44, borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    bgcolor: 'primary.dark', color: 'primary.contrastText'
                                }}
                            >
                                <AccountBalanceIcon />
                            </Box>
                        )}
                        <Box>
                            <Typography sx={{ fontWeight: 700, fontSize: { xs: '1rem', md: '1.15rem' }, lineHeight: 1.2, color: 'inherit' }}>
                                {client?.name || client?.corporateName || 'Painel da Transparência'}
                            </Typography>
                            <Typography sx={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.85)' }}>
                                Painel da Transparência — Emendas Parlamentares
                            </Typography>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>

            <Box component="main" sx={{ flexGrow: 1, bgcolor: 'grey.100', py: { xs: 3, md: 4 } }}>
                <Container maxWidth="xl">
                    {loading && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 10 }}>
                            <CircularProgress />
                            <Typography color="text.secondary">Carregando portal...</Typography>
                        </Box>
                    )}
                    {!loading && error && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, py: 10 }}>
                            <Typography variant="h6" color="text.secondary">{error}</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Verifique o endereço acessado ou tente novamente mais tarde.
                            </Typography>
                        </Box>
                    )}
                    {!loading && !error && (
                        <Grid container spacing={2}>
                            <Outlet />
                        </Grid>
                    )}
                </Container>
            </Box>

            <Box component="footer" sx={{ py: 3, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
                <Copyright />
            </Box>
        </Box>
    );
}
